const info = 
{
    title: "Free Ride",
    type: "Short Film"
};

export default info;